import {
    MarketResearchCompensationPercentileResponse,
    MarketResearchCompensationResponse,
} from ".";
import {
    currencyWholeDollarFormatter,
    MarketResearchCompensationChartPointData,
    MarketResearchCompensationData,
    MarketResearchCompensationPercentileData,
} from "../..";

export const convertMarketResearchCompensationResponse = (
    response: MarketResearchCompensationResponse
) => {
    if (!response) return null;

    const result: MarketResearchCompensationData = {
        percentiles: convertCompensationPercentilesForTable(
            response.compensationPercentiles
        ),
        regionalGraphData: convertCompensationPercentilesForChart(
            response.compensationPercentiles
        ),
        jobSalaryPercentile: response.jobSalaryPercentile,
        annualJobSalaryInUSDollars: response.annualJobSalaryInUSDollars,
        isRemote: response.isRemote,
    };
    return result;
};

const convertCompensationPercentilesForTable = (
    res: MarketResearchCompensationPercentileResponse[]
) => {
    if (!res) return null;
    const initial: Partial<MarketResearchCompensationPercentileData>[] = [
        {
            location: "Regional",
        },
        {
            location: "National",
        },
    ];

    const result = res.reduce((acc, r) => {
        acc[0][r.percentile.toString()] = currencyWholeDollarFormatter.format(
            r.regionalInUSDollars
        );
        acc[1][r.percentile.toString()] = currencyWholeDollarFormatter.format(
            r.nationalInUSDollars
        );
        return acc;
    }, initial);

    return result as MarketResearchCompensationPercentileData[];
};

const convertCompensationPercentilesForChart = (
    res: MarketResearchCompensationPercentileResponse[]
) => {
    if (!res) return null;

    const chartPointArray = res.map(r => ({
        salary: r.regionalInUSDollars,
        percentile: r.percentile,
    }));

    return chartPointArray as MarketResearchCompensationChartPointData[];
};
